<template>
  <div>
    <h1>{{ ! finished ? 'When does SAAS come in?' : 'SAAS comes in today!' }}</h1>
    <div class="timer">
      <div class="timer-unit" :class="{ finished }">
        <h1>{{ display[ 0 ] }}</h1>
        <p>Days</p>
        <img src="images/rick.png" alt="">
      </div>
      <div class="timer-unit" :class="{ finished }">
        <h1>{{ display[ 1 ] }}</h1>
        <p>Hours</p>
        <img src="images/rick.png" alt="">
      </div>
      <div class="timer-unit" :class="{ finished }">
        <h1>{{ display[ 2 ] }}</h1>
        <p>Minutes</p>
        <img src="images/rick.png" alt="">
      </div>
      <div class="timer-unit" :class="{ finished }">
        <h1>{{ display[ 3 ] }}</h1>
        <p>Seconds</p>
        <img src="images/rick.png" alt="">
      </div>
      <p>{{ this.next.toFormat( 'DDDD' ) }}</p>
    </div>
  </div>
</template>

<script>
import { DateTime, Duration } from 'luxon';
import Payment from '@/payment';

const dayAsMilliseconds = 86400000;

export default {
  name: 'Countdown',
  data() {
    return {
      now   : DateTime.local().set( { milliseconds: 0 } ),
      next  : this.getNextPaymentDate(),
      ticker: null
    }
  },
  computed: {
    remaining() {
      return this.next.diff( this.now ).toObject();
    },
    display() {
      return Duration.fromObject( this.remaining )
                     .toFormat( 'd:hh:mm:ss' )
                     .split( ':' );
    },
    finished() {
      return this.now >= this.next;
    }
  },
  watch   : {
    remaining() {
      if ( this.finished && this.remaining.milliseconds <= -dayAsMilliseconds ) {
        this.getNextPaymentDate();
      }
    },
    finished( value ) {
      if ( value ) this.deployConfetti();
    }
  },
  methods : {
    getNextPaymentDate: () => Payment.date(),
    setNextPaymentDate: () => this.next = this.getNextPaymentDate(),
    deployConfetti    : () => require( './confetti' )
  },
  mounted() {
    this.ticker = setInterval( () => {
      this.now = DateTime.local().set( { milliseconds: 0 } );
    }, 1000 );

    if ( this.finished ) this.deployConfetti();
  }
}
</script>

<style lang="scss" scoped>

</style>
